import Blockquote from "@tiptap/extension-blockquote";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    blockquote: {
      toggleColoredBlockquote: (color: string) => ReturnType;
    };
  }
}

const ColoredBlockquote = Blockquote.extend({
  addCommands() {
    return {
      ...this.parent?.(),
      toggleColoredBlockquote:
        (color: string) =>
        ({ commands }) => {
          return commands.toggleWrap(this.name, {
            background: color,
          });
        },
    };
  },

  addAttributes() {
    return {
      background: {
        default: null,
        renderHTML: (attributes) => {
          return {
            style: `background-color: ${attributes.background}`,
          };
        },
      },
    };
  },
});

export default ColoredBlockquote;
